export default __webpack_public_path__ + "static/media/acuadori.0012124c.ico";